import { AxiosResponse } from 'axios';
import { SET_EMPLOYEE_PAYROLLS, SET_EMPLOYEE_PAYROLL, SET_ERRORMSG, SET_EMPLOYEE_PAYROLL_STATS } from '@/store/mutation_types';
import {
  CLEAR_EMPLOYEE_PAYROLL_ISLOADING,
  DELETE_EMPLOYEE_PAYROLL,
  EDIT_EMPLOYEE_PAYROLL,
  GET_EMPLOYEE_PAYROLLS,
  GET_EMPLOYEE_PAYROLL,
  REGISTER_EMPLOYEE_PAYROLL,
  GET_EMPLOYEE_PAYROLL_STATS,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import EmployeePayroll from '@/services/employee_payroll';
import { Module } from 'vuex';
import { EditEmployeePayroll, RegisterEmployeePayroll, GetEmployeePayroll } from '@/dtos/employee_payroll.dto';

const employeePayroll: Module<any, {}> = {
  state: {
    employeePayroll: {
      data: null,
      isLoading: false,
    },
    employeePayrolls: {
      data: null,
      isLoading: false,
    },
    employeePayrollStats: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    employeePayroll: (state: { employeePayroll: any }) => state.employeePayroll,
    employeePayrolls: (state: { employeePayrolls: any }) => state.employeePayrolls,
    employeePayrollStats: (state: { employeePayrollStats: any }) => state.employeePayrollStats,
  },
  mutations: {
    [SET_EMPLOYEE_PAYROLL]: (
      state: { employeePayroll: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeePayroll.data = payload.data) : null,
        (state.employeePayroll.isLoading = payload.isLoading);
    },
    [SET_EMPLOYEE_PAYROLLS]: (
      state: { employeePayrolls: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeePayrolls.data = payload.data) : null,
        (state.employeePayrolls.isLoading = payload.isLoading);
    },
    [SET_EMPLOYEE_PAYROLL_STATS]: (
      state: { employeePayrollStats: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeePayrollStats.data = payload.data) : null,
        (state.employeePayrollStats.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_EMPLOYEE_PAYROLL]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_PAYROLL, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeePayroll.registerEmployeePayroll(
        payload as RegisterEmployeePayroll
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_PAYROLL, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_PAYROLL, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_PAYROLL, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_PAYROLLS]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_PAYROLLS, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeePayroll.getEmployeePayrolls(
        payload as GetEmployeePayroll
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_PAYROLLS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_PAYROLLS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_PAYROLLS, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_PAYROLL_STATS]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_PAYROLL_STATS, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeePayroll.getEmployeePayrollStats(
        payload as GetEmployeePayroll
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_PAYROLL_STATS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_PAYROLL_STATS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_PAYROLL_STATS, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_PAYROLL]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_PAYROLL, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeePayroll.getEmployeePayrolls(
        payload as GetEmployeePayroll
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_PAYROLL, { data: result.data.data[0], isLoading: false });
          return result.data.data[0];
        }
        commit(SET_EMPLOYEE_PAYROLL, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_PAYROLL, { isLoading: false });
        return false;
      }
    },
    [EDIT_EMPLOYEE_PAYROLL]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_PAYROLL, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeePayroll.editEmployeePayroll(
        payload as EditEmployeePayroll
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_PAYROLL, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_PAYROLL, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_PAYROLL, { isLoading: false });
        return false;
      }
    },
    [DELETE_EMPLOYEE_PAYROLL]: async ({ commit }: any, payload: string) => {
      commit(SET_EMPLOYEE_PAYROLL, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeePayroll.deleteEmployeePayroll(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_PAYROLL, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_PAYROLL, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_PAYROLL, { isLoading: false });
        return false;
      }
    },
    [CLEAR_EMPLOYEE_PAYROLL_ISLOADING]: ({ commit }) => {
      commit(SET_EMPLOYEE_PAYROLL, { isLoading: false });
      commit(SET_EMPLOYEE_PAYROLLS, { isLoading: false });
    },
  },
};

export default employeePayroll;
